import React from 'react';
import { Zap, Shield, Cpu, Battery, Wifi, Eye } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/translations';

const Innovation = () => {
  const { language } = useLanguage();
  const t = translations[language].innovation;

  const icons = [
    <Zap className="h-12 w-12" />,
    <Shield className="h-12 w-12" />,
    <Cpu className="h-12 w-12" />,
    <Battery className="h-12 w-12" />,
    <Wifi className="h-12 w-12" />,
    <Eye className="h-12 w-12" />,
  ];

  const innovations = t.grid.items.map((item, index) => ({
    ...item,
    icon: icons[index]
  }));

  return (
    <div className="min-h-screen bg-white pt-[120px]">
      {/* Hero Section */}
      <div className="relative h-[70vh] bg-gradient-to-br from-gray-900 via-gray-800 to-red-900">
        <div className="absolute inset-0 bg-black/30" />
        <div className="relative h-full flex items-center justify-center text-center">
          <div className="max-w-4xl px-4">
            <h1 className="text-6xl md:text-7xl font-bold text-white mb-6">{t.hero.title}</h1>
            <p className="text-2xl text-white/90 mb-8">
              {t.hero.subtitle}
            </p>
          </div>
        </div>
      </div>

      {/* Innovations Grid */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">{t.grid.title}</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t.grid.desc}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {innovations.map((innovation, index) => (
            <div
              key={index}
              className="group p-8 bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <div className="text-red-600 mb-6 transform group-hover:scale-110 transition-transform">
                {innovation.icon}
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{innovation.title}</h3>
              <p className="text-gray-600 leading-relaxed">{innovation.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Research Section */}
      <div className="bg-gray-50 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">{t.research.title}</h2>
              <p className="text-lg text-gray-600 mb-6">
                {t.research.desc}
              </p>
              <ul className="space-y-4">
                {t.research.list.map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-red-600 rounded-full mt-2" />
                    <span className="text-gray-700">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="relative h-96 rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://images.pexels.com/photos/65623/vehicle-chrome-technology-automobile-65623.jpeg"
                alt="Research"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Innovation;